/* Laboranta v4 – 24.09.2026 */

(function(){
  var P=window.LB_P||{},FREE=window.LB_FREE||30000;
  var NOTES={
    'kawa-speciality-brazylia':'kakao · karmel · orzech',
    'kawa-speciality-etiopia':'cytryna · karmel · owoce',
    'kawa-speciality-gwatemala-huehuetenango':'kwiaty · miód · wiśnia',
    'kawa-speciality-etiopia-z-lawenda':'cytrus · karmel · lawenda',
    'kawa-w-opakowaniu-ozdobnym':'3 kawy do wyboru'
  };
  var GOPR_IMG='https://cdn.shopify.com/s/files/1/1055/4628/5405/files/31_odznaka_GOPR_pionowa_na-ciemne-tlo.png?v=1789978587&width=300';
  function zl(c){return (c/100).toFixed(2).replace('.',',')+' zł'}
  function zlShort(c){return c%100===0?(c/100)+' zł':zl(c)}
  function fmt(r){return (Math.round(r*10)/10).toFixed(1).replace('.',',')}
  function grams(w){var m=String(w||'').match(/(\d+)\s*g/i);if(!m)return '';var n=+m[1];return n>=1000?(n/1000).toString().replace('.',',')+' kg':n+' g'}
  function handleFrom(href){var m=(href||'').match(/\/products\/([^/?#]+)/);return m&&m[1]}
  function stars(r,n,cls){
    var a=document.createElement(cls==='pdp'?'a':'div');a.className='lb-stars lb-stars--'+cls;a.href='#opinie';
    a.innerHTML='<i>★★★★★<b style="width:'+(r/5*100)+'%">★★★★★</b></i><span>'+fmt(r)+' · '+n+' opinii</span>';
    return a;
  }

  /* ----- kafelki: gwiazdki, nuty, waga przy cenie ----- */
  function cards(){
    document.querySelectorAll('product-card').forEach(function(c){
      var a=c.querySelector('a[ref="productTitleLink"]')||c.querySelector('a[href*="/products/"]');
      var h=handleFrom(a&&a.getAttribute('href')),D=h&&P[h];if(!D)return;
      var tb=a.querySelector('.text-block')||a.firstElementChild,tp=tb&&tb.querySelector('p');
      if(tp){var tn0=tp.firstChild;if(tn0&&tn0.nodeType===3&&/^Kawa Speciality /.test(tn0.nodeValue))tn0.nodeValue=tn0.nodeValue.replace(/^Kawa Speciality /,'')}
      if(!c.querySelector('.lb-cmeta')){
        var html='<span class="lb-cstars">'+(D.n>=3&&D.r>0?'<i>★</i>'+fmt(D.r)+' <small>('+D.n+')</small>':'')+'</span><span class="lb-cnotes">'+(NOTES[h]||'')+'</span>';
        var m=document.createElement('div');m.className='lb-cmeta';m.innerHTML=html;a.insertAdjacentElement('afterend',m);
        if(tb){var cs=getComputedStyle(tb);m.style.paddingLeft=cs.paddingLeft;m.style.paddingRight=cs.paddingRight}
      }
      var g=grams(D.w),pr=c.querySelector('product-price .price');
      if(g&&pr&&!c.querySelector('.lb-cw')){var s=document.createElement('span');s.className='lb-cw';s.textContent=' · '+g;pr.insertAdjacentElement('afterend',s)}
    });
  }

  /* ----- karta produktu: gwiazdki pod tytułem + przewijanie do opinii ----- */
  function revTarget(){
    var L=['#judgeme_product_reviews','.jdgm-review-widget','.jdgm-review-snippet-widget-v2','.jdgm-rev-snippet-widget-v2__inner','.jdgm-widget'];
    for(var i=0;i<L.length;i++){var els=document.querySelectorAll(L[i]);for(var k=0;k<els.length;k++){var e=els[k];if(/modal/.test(e.className)||e.closest('dialog'))continue;if(e.offsetHeight>30)return e}}
    return null;
  }
  function pdp(){
    var h=handleFrom(location.pathname),D=h&&P[h];if(!D||!D.n||document.querySelector('.lb-stars--pdp'))return;
    var t=document.querySelector('[id*="__main"] h1');if(!t)return;
    var s=stars(D.r,D.n,'pdp');
    s.addEventListener('click',function(e){e.preventDefault();var w=revTarget();if(!w)return;var hd=document.querySelector('#header-component .header__row--top'),off=Math.max(hd?hd.getBoundingClientRect().bottom:0,90)+20;window.scrollTo({top:Math.max(0,w.getBoundingClientRect().top+window.scrollY-off),behavior:'smooth'})});
    (t.closest('.text-block')||t).insertAdjacentElement('afterend',s);
  }

  /* ----- karta produktu i szybkie dodawanie: cena na przycisku wagi ----- */
  var PJ={};
  function prodFor(vp){
    var u=(vp.getAttribute('data-product-url')||location.pathname).split('?')[0];
    if(!/\/products\//.test(u))return null;
    if(PJ[u]===undefined){PJ[u]=null;fetch(u+'.js').then(function(r){return r.json()}).then(function(d){PJ[u]=d;run()}).catch(function(){})}
    return PJ[u];
  }
  function niceW(v){var g=grams(v);return g||v}
  function weights(){
    document.querySelectorAll('variant-picker').forEach(function(vp){
      var p=prodFor(vp);if(!p)return;
      var wIdx=p.options.findIndex(function(o){return /waga/i.test(o.name||o)});if(wIdx<0)return;
      var ins=vp.querySelectorAll('input[type=radio]');if(!ins.length)return;
      var chk=vp.querySelector('input[type=radio]:checked');
      var cur=(chk&&p.variants.find(function(v){return String(v.id)===chk.getAttribute('data-variant-id')}))||p.selected_or_first_available_variant||p.variants[0];
      var others=function(v){return v.options.filter(function(_,i){return i!==wIdx}).join('|')},key=others(cur);
      function vFor(w){return p.variants.find(function(v){return v.options[wIdx]===w&&others(v)===key})}
      var best=null,bestU=1e12,first=null;
      ins.forEach(function(i){var v=vFor(i.value),g=parseInt(i.value,10);if(!first)first=i.value;if(v&&g){var u=v.price/g;if(u<bestU-0.01){bestU=u;best=i.value}}});
      ins.forEach(function(i){
        var l=i.closest('.variant-option__button-label');if(!l)return;
        var t=l.querySelector('.variant-option__button-label__text');if(!t)return;
        var old=t.querySelector('.lb-kg');if(old)old.remove();
        var tn=null;for(var k=0;k<t.childNodes.length;k++){if(t.childNodes[k].nodeType===3&&t.childNodes[k].nodeValue.trim()){tn=t.childNodes[k];break}}
        var nice=niceW(i.value);if(tn&&tn.nodeValue.trim()!==nice)tn.nodeValue=nice;
        var pe=t.querySelector('.lb-vp');if(pe)pe.remove();
        var old2=l.querySelector('.lb-best');if(old2)old2.remove();
        if(best&&best!==first&&i.value===best){
          var fs=l.closest('fieldset');if(fs){var tag=fs.querySelector(':scope > .lb-best');if(!tag){tag=document.createElement('span');tag.className='lb-best';tag.textContent='najkorzystniej';fs.appendChild(tag)}
          var X=(l.offsetLeft+l.offsetWidth/2)+'px';if(tag.style.left!==X)tag.style.left=X;var lr=l.getBoundingClientRect(),cr=tag.getBoundingClientRect(),d=lr.top-(cr.top+cr.height/2);if(Math.abs(d)>1)tag.style.top=((parseFloat(tag.style.top)||0)+d)+'px'}
        }
      });
      if(!best||best===first){var fs0=vp.querySelector('fieldset > .lb-best');if(fs0)fs0.remove()}
    });
  }

  /* ----- karta produktu: kiedy wyślemy (dni robocze, polskie święta) ----- */
  function waw(){
    var o={};new Intl.DateTimeFormat('en-GB',{timeZone:'Europe/Warsaw',year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',minute:'2-digit',second:'2-digit',hourCycle:'h23'}).formatToParts(new Date()).forEach(function(x){o[x.type]=x.value});
    return {y:+o.year,m:+o.month,d:+o.day,h:+o.hour,mi:+o.minute,s:+o.second};
  }
  function easter(y){var a=y%19,b=Math.floor(y/100),c=y%100,d=Math.floor(b/4),e=b%4,f=Math.floor((b+8)/25),g=Math.floor((b-f+1)/3),h=(19*a+b-d-g+15)%30,i=Math.floor(c/4),k=c%4,l=(32+2*e+2*i-h-k)%7,m=Math.floor((a+11*h+22*l)/451),mo=Math.floor((h+l-7*m+114)/31),da=((h+l-7*m+114)%31)+1;return Date.UTC(y,mo-1,da)}
  var DAY=864e5;
  function workday(t){var dt=new Date(t),wd=dt.getUTCDay();if(wd===0||wd===6)return false;var md=(dt.getUTCMonth()+1)*100+dt.getUTCDate();if([101,106,501,503,815,1101,1111,1224,1225,1226].indexOf(md)>=0)return false;var e=easter(dt.getUTCFullYear());return t!==e+DAY&&t!==e+60*DAY}
  function shipText(){
    var n=waw(),today=Date.UTC(n.y,n.m-1,n.d),secs=n.h*3600+n.mi*60+n.s,cut=(window.LB_CUTOFF||14)*3600;
    if(workday(today)&&secs<cut){var tot=Math.ceil((cut-secs)/60),h=Math.floor(tot/60),m=tot%60;return 'Zamów w ciągu <b>'+((h?h+' h ':'')+(m?m+' min':'')).trim()+'</b>, a wyślemy dziś'}
    var t=today+DAY,i=0;while(!workday(t)&&i<10){t+=DAY;i++}
    var diff=Math.round((t-today)/DAY),N=['w niedzielę','w poniedziałek','we wtorek','w środę','w czwartek','w piątek','w sobotę'];
    return 'Zamów teraz, a wyślemy <b>'+(diff===1?'jutro':N[new Date(t).getUTCDay()])+'</b>';
  }
  function today(){
    if(!window.LB_PL||!/\/products\//.test(location.pathname))return;
    var bb=[].slice.call(document.querySelectorAll('[id*="__main"] .buy-buttons-block')).filter(function(x){return !x.closest('dialog')})[0];if(!bb)return;
    var el=document.querySelector('.lb-today');
    if(!el){el=document.createElement('div');el.className='lb-today';el.innerHTML='<span class="lb-today__dot"></span><span class="lb-today__t"></span>';bb.insertAdjacentElement('beforebegin',el)}
    var tx=shipText(),t=el.querySelector('.lb-today__t');if(t.innerHTML!==tx)t.innerHTML=tx;
  }

  /* ----- karta produktu: odznaka GOPR na zdjęciu, prawy górny róg (tylko kawy) ----- */
  function gopr(){
    var h=handleFrom(location.pathname);if(!h||!/^kawa/.test(h))return;
    var g=[].slice.call(document.querySelectorAll('[id*="__main"] media-gallery, [id*="__main"] .product-media-gallery, [id*="__main"] slideshow-component')).filter(function(x){return !x.closest('dialog')&&x.offsetHeight>100})[0];
    if(!g||g.querySelector('.lb-gopr'))return;
    if(getComputedStyle(g).position==='static')g.style.position='relative';
    var d=document.createElement('div');d.className='lb-gopr';
    d.innerHTML='<img src="'+GOPR_IMG+'" alt="Oficjalna kawa Grupy Karkonoskiej GOPR" width="300" height="324">';
    g.appendChild(d);
  }

  /* ----- koszyk: pasek darmowej dostawy + dobieranie blisko progu ----- */
  var cart=null,busy=false;
  function ship(){
    if(!cart)return;
    var t=cart.total_price,left=FREE-t,pct=Math.min(100,t/FREE*100);
    var el=document.querySelector('cart-drawer-component .cart-drawer__items, .cart-page .cart-items, .main-cart .cart-items');
    if(!el)return;
    var host=el.parentElement,b=host.querySelector(':scope > .lb-ship');
    if(!cart.item_count){if(b)b.remove();var u0=host.querySelector(':scope > .lb-up');if(u0)u0.remove();return}
    if(!b){b=document.createElement('div');b.className='lb-ship';b.innerHTML='<div class="lb-ship__t"></div><div class="lb-ship__bar"><span style="width:0"></span></div>';el.insertAdjacentElement('beforebegin',b)}
    var k=String(t);
    if(b.getAttribute('data-t')!==k){
      b.setAttribute('data-t',k);b.classList.toggle('done',left<=0);
      b.querySelector('.lb-ship__t').innerHTML=left<=0?'Masz <b>darmową dostawę</b>':(t<FREE/2?'Darmowa dostawa od <b>'+zlShort(FREE)+'</b>':'Jeszcze <b>'+zl(left)+'</b> do darmowej dostawy');
      requestAnimationFrame(function(){var s=b.querySelector('.lb-ship__bar span');if(s)s.style.width=pct+'%'});
    }
    /* propozycja dobrania: tylko gdy brakuje najwyżej 150 zł */
    var up=host.querySelector(':scope > .lb-up'),u=(left>0&&left<=15000)?pickUp():null;
    if(u){var html=upHTML(u);if(!up){up=document.createElement('div');up.className='lb-up';el.insertAdjacentElement('afterend',up)}if(up.getAttribute('data-h')!==html){up.setAttribute('data-h',html);up.innerHTML=html}}
    else if(up)up.remove();
    if(left>0&&left<=15000)loadUp();
  }
  var UP=['kawa-speciality-brazylia','kawa-speciality-etiopia','kawa-speciality-gwatemala-huehuetenango'],UPP={},upBusy=false;
  function loadUp(){if(upBusy||Object.keys(UPP).length)return;upBusy=true;Promise.all(UP.map(function(h){return fetch('/products/'+h+'.js').then(function(r){return r.json()}).then(function(p){UPP[h]=p}).catch(function(){})})).then(function(){upBusy=false;ship()})}
  function pickUp(){
    if(!cart)return null;var left=FREE-cart.total_price;if(left<=0)return null;
    var inCart={},grind=null;cart.items.forEach(function(i){inCart[i.handle]=(inCart[i.handle]||0)+i.quantity;(i.options_with_values||[]).forEach(function(o){if(/mielenie/i.test(o.name)&&!grind)grind=o.value})});
    var hs=UP.filter(function(h){return UPP[h]}).sort(function(a,b){return (inCart[a]||0)-(inCart[b]||0)});
    var weights=left>4500?['500g','200g']:['200g'];
    for(var w=0;w<weights.length;w++){for(var k=0;k<hs.length;k++){
      var p=UPP[hs[k]],wi=p.options.findIndex(function(o){return /waga/i.test(o.name||o)}),gi=p.options.findIndex(function(o){return /mielenie/i.test(o.name||o)});
      var v=p.variants.find(function(v){return v.available&&v.options[wi]===weights[w]&&(gi<0||v.options[gi]===(grind||'Kawa w ziarnach'))})||p.variants.find(function(v){return v.available&&v.options[wi]===weights[w]});
      if(v&&(weights[w]==='200g'||v.price>=left))return {p:p,v:v,w:weights[w],g:gi>=0?v.options[gi]:''};
    }}
    return null;
  }
  function upHTML(u){
    var left=FREE-cart.total_price,img=(u.v.featured_image&&u.v.featured_image.src)||u.p.featured_image||'';
    if(img)img=img.replace(/(\.[a-z]+)(\?|$)/i,'$1?width=120&');
    var name=u.p.title.replace(/^Kawa Speciality /,'').replace(/ Huehuetenango$/,'');
    return (img?'<img src="'+img+'" alt="" loading="lazy">':'')+'<div class="lb-up__t"><b>'+name+' '+grams(u.w)+'</b>'+(u.v.price>=left?'<small class="lb-up__free">Z nią masz darmową dostawę · '+zl(u.v.price)+'</small>':'<small>'+u.g+' · '+zl(u.v.price)+'</small>')+'</div><button type="button" data-v="'+u.v.id+'">Dodaj</button>';
  }
  document.addEventListener('click',function(e){
    var btn=e.target.closest('.lb-up button');if(!btn)return;e.preventDefault();e.stopPropagation();btn.disabled=true;btn.textContent='…';
    var secs=[];document.querySelectorAll('[data-section-id]').forEach(function(el){if(secs.indexOf(el.dataset.sectionId)<0)secs.push(el.dataset.sectionId)});
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:+btn.getAttribute('data-v'),quantity:1,sections:secs})})
    .then(function(r){return r.json()}).then(function(d){
      document.dispatchEvent(new CustomEvent('cart:update',{bubbles:true,detail:{resource:d,sourceId:'lb-upsell',data:{sections:d.sections||{},itemCount:d.item_count,variantId:btn.getAttribute('data-v')}}}));
      setTimeout(loadCart,200);
    }).catch(function(){btn.disabled=false;btn.textContent='Dodaj'});
  },true);

  function loadCart(){if(busy)return;busy=true;fetch('/cart.js').then(function(r){return r.json()}).then(function(c){cart=c;window.LB_CART=c;busy=false;document.documentElement.classList.toggle('lb-hascart',c.item_count>0);ship()}).catch(function(){busy=false})}

  /* ----- nagłówek polecanych na karcie produktu ----- */
  function recHead(){
    document.querySelectorAll('product-recommendations h3, [class*="product-recommendations"] h3, [id*="product_recommendations"] h3').forEach(function(h){if(/spodoba/i.test(h.textContent)&&!h.hasAttribute('data-lb')){h.setAttribute('data-lb','1');h.innerHTML='<em><strong>Spróbuj też</strong></em>'}});
  }
  /* ----- popup 10%: gdy w koszyku coś jest, zamykamy go od razu ----- */
  function guardPopup(){
    if(!cart||!cart.item_count)return;
    var r=document.querySelector('.react-responsive-modal-root');if(!r||r.hasAttribute('data-lb')||!r.querySelector('[class*="ecomsend"]'))return;
    r.setAttribute('data-lb','1');
    var b=r.querySelector('.react-responsive-modal-closeButton,button[class*="lose"],[class*="lose"] button,button[aria-label*="lose"],button[aria-label*="amknij"]');
    if(b)b.click();else document.dispatchEvent(new KeyboardEvent('keydown',{key:'Escape',keyCode:27,bubbles:true}));
  }
  var mt;
  function coll(){if(/\/collections\/kawa-speciality/.test(location.pathname))document.documentElement.classList.add('lb-coll-kawa')}
  function run(){coll();cards();pdp();weights();today();gopr();ship();recHead();guardPopup()}
  function init(){
    run();loadCart();
    setInterval(today,30000);
    addEventListener('resize',function(){clearTimeout(mt);mt=setTimeout(run,150)});
    document.addEventListener('cart:update',function(){setTimeout(loadCart,150)});
    document.addEventListener('variant:update',function(){setTimeout(weights,60)});
    new MutationObserver(function(){clearTimeout(mt);mt=setTimeout(run,120)}).observe(document.body,{childList:true,subtree:true});
    var of=window.fetch;window.fetch=function(){var a=arguments,u=String(a[0]&&a[0].url||a[0]);return of.apply(this,a).then(function(r){if(/\/cart\/(add|change|update|clear)/.test(u))setTimeout(loadCart,100);return r})};
  }
  if(document.readyState!=='loading')init();else document.addEventListener('DOMContentLoaded',init);
})();


/* ----- karuzela opinii (strona główna) ----- */
(function(){
  function initRev(s){
    if(s.hasAttribute('data-lb'))return;s.setAttribute('data-lb','1');
    var tr=s.querySelector('.lb-rev__track'),cards=tr.querySelectorAll('.lb-rev__card'),dots=s.querySelector('.lb-rev__dots'),pr=s.querySelector('[data-dir="-1"]'),nx=s.querySelector('[data-dir="1"]');
    cards.forEach(function(){dots.appendChild(document.createElement('i'))});
    function step(){var c=cards[0];return c?c.getBoundingClientRect().width+12:300}
    function upd(){var i=Math.round(tr.scrollLeft/step()),max=tr.scrollWidth-tr.clientWidth-4;[].forEach.call(dots.children,function(d,k){d.classList.toggle('on',k===Math.min(i,cards.length-1))});pr.disabled=tr.scrollLeft<4;nx.disabled=tr.scrollLeft>=max}
    s.querySelectorAll('.lb-rev__arrow').forEach(function(b){b.addEventListener('click',function(){tr.scrollBy({left:+b.getAttribute('data-dir')*step(),behavior:'smooth'})})});
    tr.addEventListener('scroll',function(){requestAnimationFrame(upd)},{passive:true});
    addEventListener('resize',upd);upd();
  }
  function go(){document.querySelectorAll('.lb-rev').forEach(initRev)}
  if(document.readyState!=='loading')go();else document.addEventListener('DOMContentLoaded',go);
})();
